import React, { useEffect } from 'react';

/**
 * Custom hook to detect clicks outside of a specified element.
 *
 * @param ref - The reference to the element to check for clicks outside of.
 * @param handler - A callback function that is called when a click is detected outside of the element.
 *                 The argument passed to the handler function indicates whether an event occurred.
 */
const useOnClickOutside = (
  ref: React.MutableRefObject<any>,
  handler: (value: boolean) => void,
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(!!event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
